// import david from "../assets/images/advisors/international/David.jpg";
// import Mahasweta from "../assets/images/advisors/international/Mahasweta.jpg";
// import Megan from "../assets/images/advisors/international/Megan.jpg";
// import Hiis from "../assets/images/advisors/international/hiis.jpg";
// import kasthuri from "../assets/images/advisors/international/kasthuri.jpg";
// import Obinna from "../assets/images/advisors/international/Obinna.jpg";
// import Gary from "../assets/images/advisors/international/Gary.jpg";
// import oliver from "../assets/images/advisors/international/oliver.jpg";
// import Valecia from "../assets/images/advisors/international/Valecia.jpg";
import marian from "../assets/images/advisors/international/marian.jpg";
import zeeshan from "../assets/images/advisors/international/zeeshan.jpg";
import shahid from "../assets/images/advisors/international/shahid.jpg";
import Nasiruddin from "../assets/images/advisors/international/nazir-uddin.jpg";
import bunyamin from "../assets/images/advisors/international/WhatsApp Image 2025-11-04 at 14.53.29_ed7add0b.jpg";
import aymen from "../assets/images/advisors/international/prof eyman.jpg";
import abdalla from "../assets/images/advisors/international/WhatsApp Image 2025-11-11 at 11.53.25_cb3692bf.jpg";
// import Ehsan from "../assets/images/advisors/international/ehsan.jpg";
// import Asif from "../assets/images/advisors/international/Asif.jpg";

// import rage from "../assets/images/advisors/local/rage.jpg"
import bidey from "../assets/images/advisors/local/Bidey.jpg";
import fuje from "../assets/images/advisors/local/fuje.jpg";

// import jalil from "../assets/images/advisors/local/jalil.jpg"
import guled from "../assets/images/advisors/local/guled.jpg"
import mursal from "../assets/images/advisors/local/Dr. Mursa.jpg"

export const internationals = [
  // {
  //   id: 1,
  //   avatar: david,
  //   name: "David Schultz. Ph.D",
  //   occ: [
  //     {
  //       id: 1,
  //       title: "Distinguished Professor",
  //       place: "University of Minnesota",
  //     },
  //     { id: 2, title: "Hamline University", place: "" },
  //   ],
  // },
  // {
  //   id: 2,
  //   avatar: Hiis,
  //   name: "Dr. Hiis Ilmi Ph.D. MBA. M.H.A",
  //   occ: [
  //     {
  //       id: 1,
  //       title: "Sr. Academic Advisor & International Relations",
  //       place: "Benadir University",
  //     },
  //     {
  //       id: 2,
  //       title: "University of California Irvine",
  //       place: "Northwestern University",
  //     },
  //   ],
  // },
  // {
  //   id: 3,
  //   avatar: kasthuri,
  //   name: "Dr. Kasthuri Henry, PhD, CTP",
  //   occ: [
  //     {
  //       id: 1,
  //       title: "Distinguished Professor",
  //       place: "University of Chicago",
  //     },
  //     { id: 2, title: "Global Humanistic University", place: "" },
  //   ],
  // },
  // {
  //   id: 4,
  //   avatar: Megan,
  //   name: "Megan Mankerian.",
  //   occ: [
  //     {
  //       id: 1,
  //       title: "M.APrincipal Expert",
  //       place: "International Education Advisor",
  //     },
  //     { id: 2, title: "Creighton University Omaha, Nebraska (USA)", place: "" },
  //   ],
  // },
  // {
  //   id: 5,
  //   avatar: Obinna,
  //   name: "Obinna Onyekwana MD, MHA",
  //   occ: [
  //     {
  //       id: 1,
  //       title: "Deputy Director",
  //       place: "Bill & Melinda Gates Foundation",
  //     },
  //   ],
  // },
  // {
  //   id: 6,
  //   avatar: Mahasweta,
  //   name: "Mahasweta Sakar, Ph.D.",
  //   occ: [
  //     {
  //       id: 1,
  //       title: "Senior Associate Dean & Professor",
  //       place: "San Diego State University",
  //     },
  //   ],
  // },
  // {
  //   id: 7,
  //   avatar: Gary,
  //   name: "Gary L. Kreps Ph.D",
  //   occ: [
  //     {
  //       id: 1,
  //       title: "Distinguished Professor",
  //       place: "George Mason University",
  //     },
  //     {
  //       id: 2,
  //       title: "Executive Director and Professor",
  //       place: "University of Nevada, Las Vegas",
  //     },
  //     {
  //       id: 3,
  //       title: "Professor and Director of Graduate Studies",
  //       place: "Northern Illinois University",
  //     },
  //   ],
  // },
  // {
  //   id: 8,
  //   avatar: oliver,
  //   name: "Oliver William, Ph.D. M.P.H. MSW",
  //   occ: [
  //     {
  //       id: 1,
  //       title: "Distinguished Professor",
  //       place: "University of Minnesota",
  //     },
  //   ],
  // },
  // {
  //   id: 9,
  //   avatar: Valecia,
  //   name: "Dr. Valecia Baldwin. Ph.D.",
  //   occ: [{ id: 1, title: "Virginia University", place: "" }],
  // },
  {
    id: 10,
    avatar: marian,
    name: "Marian Warsame, MD, MSc, Ph.D.",
    occ: [
      {
        id: 1,
        title: "Senior Researcher",
        place: "School of Public Health and Community Medicine",
      },
      { id: 1, title: "University of Gothenburg, Sweden", place: "" },
    ],
  },
  {
    id: 11,
    avatar: shahid,
    name: "Prof. Dr. Shahid Pervez",
    occ: [
      {
        id: 1,
        title: "M.B., B.S., D.C.P. (London), Ph.D. (Histopath. London),",
        place: "FCPS (Histopath. Pakistan), FRCPath (UK)",
      },
      { id: 2, title: "COMSTECH Distinguished Scholar", place: "Professor & Consultant Histopathology," },
      { id: 3, title: "Departments of Pathology & Laboratory Medicine", place: "Faculty of Health Sciences" },
      { id: 4, title: "Medical College, The Aga Khan University", place: "" },
    ],
  },
  {
    id: 12,
    avatar: zeeshan,
    name: "Dr. Zeeshan Uddin",
    occ: [
      {
        id: 1,
        title: "Assistant Professor and Consultant Histopathologist",
        place: "The Aga Khan University, Karachi, Pakistan",
      }
    ],
  },
  {
    id: 13,
    avatar: Nasiruddin,
    name: "Dr. Nasiruddin, MBBS, FCPS (Histo, PK)",
    occ: [
      {
        id: 1,
        title: "FRCPath (Histo, UK)",
        place: "General Histopathology, Bone and Soft Tissue, Head & Neck",
      },
      { id: 2, title: "The Aga Khan University, Karachi, Pakistan.", place: "" },
    ],
  },
  {
    id: 14,
    avatar: bunyamin,
    name: "Prof. Dr. Bünyamin Şahin",
    occ: [
      {
        id: 1,
        title: "Professor of Anatomy",
        place: "Specializing in quantitative neuroanatomy, brain segmentation, and stereological analysis",
      },
      { 
        id: 2, 
        title: "Former Rector, Vice Rector, and Dean at several Turkish universities", 
        place: "Author of 85+ SCI-indexed papers (h-index: 35)" 
      },
      { 
        id: 3, 
        title: "Over 35 years of academic experience", 
        place: "Expert in FreeSurfer and BrainSuite analysis" 
      },
    ],
  },
  {
    id: 15,
    avatar: aymen,
    name: "Prof. Dr. Aymen Ahmed Warille",
    occ: [
      {
        id: 1,
        title: "Professor of Anatomy",
        place: "Expert in human morphology, surgical anatomy, and microscopic techniques",
      },
      { 
        id: 2, 
        title: "PhD from the University of Malaya", 
        place: "Over 32 years of teaching and leadership experience across six countries" 
      },
      { 
        id: 3, 
        title: "Research in developmental and surgical anatomy, stereology, and medical education", 
        place: "Numerous SCI-indexed publications and edited anatomy books" 
      },
    ],
  },
  {
    id: 16,
    avatar: abdalla,
    name: "Prof. Abdalla Mohamed Jama",
    occ: [
      {
        id: 1,
        title: "Professor Emeritus",
        place: "BSc and PhD from University of Stockholm, MSc from Umeå University, Sweden",
      },
      { 
        id: 2, 
        title: "Research Fellow in Molecular Cell Biology", 
        place: "University of Toronto" 
      },
      { 
        id: 3, 
        title: "Research and Development Manager at Gene Therapy Center (GMP Facility)", 
        place: "Karolinska University Hospital Huddinge, Sweden" 
      },
      { 
        id: 4, 
        title: "Associate Professor of Molecular Cell Biology", 
        place: "Karolinska Institutet, Sweden" 
      },
      { 
        id: 5, 
        title: "Visiting Professor of Biochemistry and Molecular Biology", 
        place: "COMSATS University Islamabad, Pakistan" 
      },
      { 
        id: 6, 
        title: "Professor of Biochemistry and Molecular Biology", 
        place: "University of Brunei Darussalam" 
      },
      { 
        id: 7, 
        title: "Professor of Cell and Molecular Biology", 
        place: "University of Zarqa, Jordan" 
      },
      { 
        id: 8, 
        title: "Professor of Molecular Biology", 
        place: "Benadir University, Somalia" 
      },
      { 
        id: 9, 
        title: "Research focuses on molecular medicine, gene therapy, and cellular signaling", 
        place: "" 
      },
    ],
  },
  // {
  //   id: 17,
  //   avatar: Ehsan,
  //   name: "Dr. Seyed-Ehsan Elahi",
  //   occ: [
  //     {
  //       id: 1,
  //       title: "PhD, University of Minnesota.",
  //       place: "Professor University of Massachusetts Boston",
  //     }
  //   ],
  // },
  // {
  //   id: 18,
  //   avatar: Asif,
  //   name: "Prof. Dr. Sheikh Asif S. Mizan",
  //   occ: [
  //     {
  //       id: 1,
  //       title: "BSS (Hon's), MSS, MBA, MACPM & PhD Rotarian, Criminologist, Good Governance & Human Rights Expert.",
  //       place: "Former Professor & Head, Department of Political Science, Asian University of Bangladesh. Life Member of Indian Political Science Association (IPSA)",
  //     }
  //   ],
  // },
];

export const local = [
  {
    id: 0,
    avatar: bidey,
    name: "Prof. Dr. Mohamed Mohamoud Hassan (Dr. Biday)",
    bio: `Prof. Dr. Mohamed Mohamoud Hassan (Dr. Biday)
Rector of Benadir University and Chairman of the Association of Somali Universities (ASU)

Dr. Biday, born in Mogadishu, earned his MBChB from the Somali National University, where he specialized in Internal Medicine/Cardiology. He also holds a Diploma in Public Health, Disease Surveillance & Control from the Liverpool School of Tropical Medicine, UK. His medical career began as Deputy Head of the Military Medical Ward, after which he served as Assistant Consultant Cardiologist at Mogadishu General Hospital, Deputy Director of Medina Hospital, and later he became a Director of Hayat Hospital. Beyond hospital leadership, he made significant contributions to national health programs, serving as TB Program Coordinator (MOH/WHO) and Executive Director of the South & Central HIV/AIDS Commission (SCAC).

In 2002, Dr. Biday joined Benadir University, where he progressed through key academic leadership roles as Deputy Dean, Acting Dean, and Dean before being appointed as a Rector in 2018. Under his leadership, the university has continued to expand and strengthen its academic quality and research capacity. Furthermore, in 2022, he was elected Chairman of the Association of Somali Universities, through which he actively promotes university governance reforms, academic excellence, and international collaboration. Fluent in Somali, English, Arabic, and Italian, Dr. Biday is widely recognized for his outstanding leadership and lasting contributions to medicine, higher education, and public health development in Somalia.`,
    occ: [
      {
        id: 1,
        title: "Rector of Benadir University",
        place: "Chairman, Association of Somali Universities (ASU)",
      },
    ],
  },
  {
    id: 1,
    avatar: fuje,
    name: "Prof. Dr. Mohamed Mohamud Fuje",
    occ: [
      { id: 1, title: "Sr. Academic Advisor", place: "Benadir University" },
      {
        id: 2,
        title: "Professor & Dean of Postgraduate",
        place: "Benadir University",
      },
    ],
  },

  {
    id: 3,
    avatar: guled,
    name: "Prof. Dr. Ahmed Y Guled",
    occ: [
      {id: 1, title: "Sr. Consultant in Chest Medicine", place: "Benadir University"},
    ]
  },
  {
    id: 4,
    avatar: mursal,
    name: "Prof. Dr. Mursal Omar Sheikh",
    occ: [
      {
        id: 1,
        title: "Professor of Biochemistry and Medical",
        place: "Over 40 years of experience in teaching and research across Somalia, Sudan, Italy, and Saudi Arabia",
      },
      {
        id: 2,
        title: "MD from Somali National University, MSc in Biochemistry from University of Khartoum",
        place: "Advanced training in Rome, Italy",
      },
      {
        id: 3,
        title: "Former lecturer at King Abdulaziz University and Umm Al-Qura University, Saudi Arabia",
        place: "Currently serves at Benadir University, focusing on medical and biochemical education",
      },
    ]
  }
];
